import type { DateTime } from 'luxon'
import { parseDatetime } from './datetime'

type TimedWaypoint = {
  actualArrivalTimeLocal?: string | null
  conflictArrivalTimeLocal?: string | null
  scheduledArrivalTimeLocal?: string | null
  actualDepartureTimeLocal?: string | null
  conflictDepartureTimeLocal?: string | null
  scheduledDepartureTimeLocal?: string | null
}

/** A waypoint time; `isRecorded` when it comes from an actual timestamp. */
export type WaypointTime = { at: DateTime; isRecorded: boolean }

type RawTime = string | null | undefined

// Each candidate must parse, so an empty or invalid value falls through
const pickTime = (
  actual: RawTime,
  ...planned: RawTime[]
): WaypointTime | undefined => {
  const actualAt = parseDatetime(actual)
  if (actualAt) return { at: actualAt, isRecorded: true }
  const plannedAt = planned.map((time) => parseDatetime(time)).find(Boolean)
  if (!plannedAt) return undefined
  return { at: plannedAt, isRecorded: false }
}

/** Arrival shown on the timeline: actual, else conflict, else scheduled (v1). */
export const waypointArrival = (wp: TimedWaypoint): WaypointTime | undefined =>
  pickTime(
    wp.actualArrivalTimeLocal,
    wp.conflictArrivalTimeLocal,
    wp.scheduledArrivalTimeLocal,
  )

/** Departure shown on the timeline: actual, else conflict, else scheduled (v1). */
export const waypointDeparture = (
  wp: TimedWaypoint,
): WaypointTime | undefined =>
  pickTime(
    wp.actualDepartureTimeLocal,
    wp.conflictDepartureTimeLocal,
    wp.scheduledDepartureTimeLocal,
  )
